import {
  FETCH_REFFERALS_DATA,
  FETCH_REFFERALS_SUCCESS,
  FETCH_REFFERALS_FAILURE,
  FETCH_REFFERALS_EDIT_DATA,
  FETCH_REFFERALS_EDIT_SUCCESS,
  FETCH_REFFERALS_EDIT_FAILURE,
} from "./actionTypes";

export const fetchRefferalsData = () => ({
  type: FETCH_REFFERALS_DATA,
});

export const fetchRefferalsSuccess = (data) => ({
  type: FETCH_REFFERALS_SUCCESS,
  payload: data,
});

export const fetchRefferalsFailure = (error) => ({
  type: FETCH_REFFERALS_FAILURE,
  payload: error,
});

export const fetchRefferalsEditData = (id) => ({
  type: FETCH_REFFERALS_EDIT_DATA,
  payload: id,
});

export const fetchRefferalsEditSuccess = (data) => ({
  type: FETCH_REFFERALS_EDIT_SUCCESS,
  payload: data,
});

export const fetchRefferalsEditFailure = (error) => ({
  type: FETCH_REFFERALS_EDIT_FAILURE,
  payload: error,
});
